import React from 'react';
import { StyledDiv } from './StyledComponents';

// TBD: Size variations, colors, etc.
const RedDot = (): JSX.Element => <StyledDiv />;

export default RedDot;
